var counter = 0;
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    // this.filterSlider();
    
    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    FacetFiltersForm.filterSlider(); // init filter slider
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    // console.log("searchParams",searchParams);
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        // console.log("responseText",responseText);
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderCollectionBanner(html); // custom function
        counter = 0;
        FacetFiltersForm.filterSlider();
        FacetFiltersForm.renderProductCount(html);
        if (typeof initRatingSnippet === 'function') initRatingSnippet();
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderCollectionBanner(html); // custom function
    counter = 0;
    FacetFiltersForm.filterSlider();
    FacetFiltersForm.renderProductCount(html);
    if (typeof initRatingSnippet === 'function') initRatingSnippet();
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  // render collection banner -- CUSTOM
  static renderCollectionBanner(html) {
    // console.log("renderCollectionBanner");
    document.querySelector('[data-collection-banner]').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-collection-banner]').innerHTML;

    // for pagination - load more
    if(document.querySelector('.pagination-wrapper')) document.querySelector('.pagination-wrapper').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.pagination-wrapper').innerHTML;
    collectionLoadmore(); // reinit click event - define at bottom of the this section==> main-collection-product-grid.liquid
    // filterSlider();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    // console.log("parsedHTML",parsedHTML);
    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    // data-custom-filter
    let customFilter = document.querySelector("[data-custom-filter]") || null;
    if(customFilter){
      customFilter.innerHTML = html.querySelector("[data-custom-filter]").innerHTML;
    }

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  static filterSlider(){
    // console.log("filterSlider");
    if(document.body.clientWidth > 0 && counter == 0){
      // $('.custom-filter-ul:not(.slick-initialized)').slick({
      //   infinite: false,
      //   // speed: 500,
      //   slidesToShow: 1,
      //   initialSlide: 0,
      //   slidesToScroll: 5,
      //   variableWidth: true,
      //   // centerPadding: "0",
      //   centerMode: false
      //   // prevArrow: "<button class='slider-arr slider-prev'><</button>",
      //   // nextArrow: "<button class='slider-arr slider-next'>></button>"
      // });
      // let slideWidth = 0;
      // $(".custom-filter-ul .list-menu__item").each(function(index,item){
      //   // console.log("item",$(item));
      //   slideWidth += $(item).outerWidth();
      // });
      // console.log("slideWidth",slideWidth);
      // if($(".custom-filter-ul").width() > slideWidth){
      //   $(".custom-filter-ul").addClass("no-transform"); // do css with this class
      // }

      // console.log("custom scroll",counter);
      // if(counter == 0){
          var instance = $(".custom-filter");
          $.each( instance, function(key, value) {    
            var arrows = $(instance[key]).find(".slick-arrow"),
                prevArrow = arrows.filter('.slick-prev'),
                nextArrow = arrows.filter('.slick-next'),
                box = $(instance[key]).find('.custom-filter-ul'), 
                x = 0,y = 0,
                mx = 0,
                maxScrollWidth = box[0].scrollWidth - (box[0].clientWidth / 2) - (box.width() / 2);  
            // console.log("arrows",arrows);
            var cnt = 1, cnt2 = 1;
            $(arrows).on('click', function(e) {
              e.preventDefault();
              // console.log("arr",this,"box",box);
              if ($(this).hasClass("slick-next")) {
                y=0;cnt2--;
                x = parseInt($('.custom-filter-ul .list-menu__item').width() * cnt); //((box.width() / 2)) + box.scrollLeft() - 10;
                box.animate({
                  scrollLeft: x,
                });
                cnt++;
              } else {
                x=0;cnt--;
                y = parseInt($('.custom-filter-ul .list-menu__item').width() * cnt2); //((box.width() / 2)) - box.scrollLeft() -10;
                box.animate({
                  scrollLeft: -y,
                });
                cnt2++;
              }
            });
              
            $(box).on({
              mousemove: function(e) {
                var mx2 = e.pageX - this.offsetLeft;
                if(mx) this.scrollLeft = this.sx + mx - mx2;
              },
              mousedown: function(e) {
                this.sx = this.scrollLeft;
                mx = e.pageX - this.offsetLeft;
              },
              scroll: function() {
                toggleArrows();
              }
            });
          
            $(document).on("mouseup", function(){
              mx = 0;
            });
            
            function toggleArrows() {
              if(box.scrollLeft() > maxScrollWidth - 10) {
                  // disable next button when right end has reached 
                nextArrow.addClass('disabled');
                prevArrow.removeClass('disabled');
                } else if(box.scrollLeft() < 10) {
                  // disable prev button when left end has reached 
                  prevArrow.addClass('disabled')
                } else{
                  // both are enabled
                  nextArrow.removeClass('disabled');
                  prevArrow.removeClass('disabled');
                }
            }
            
          });
          // end custom scroll
          counter++;
        // }

      window.scrollTo(0,0); // go to top
      
    }
    let content = document.querySelector("[coll-banner-content]") || null;
    if (content && document.body.clientWidth <= 749) {
      let height = content.clientHeight + 50;
      if (document.querySelector("[data-collection-banner] .video-wrap")) {
        document.querySelector("[data-collection-banner] .video-wrap img.mobile").style.height = `${height}px`;
      } else {
        document.querySelector("[data-collection-banner] .tr-collection-pg-tp-bnr-inn img.mobile").style.height = `${height + 20}px`;
      }
    }
    // set active at left side
    if(document.querySelector(".list-menu__item.active:not(.all-pro-li)")){ 
      let left = document.querySelector(".list-menu__item.active").offsetLeft;
      document.querySelector(".custom-filter-ul").scrollTo((left - 35),0);
    }

    // reinit review
    // if(trustspotWidgetList.includes("trustspot-inline-category")) trustspotInit();
    
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    // console.log("onSubmitHandler",event.target);

    // remove multiple select -- if have
    let attr = event.target.getAttribute("name") || null;
    if(attr && attr == "filter.p.m.custom.shop_by_product" || attr == "filter.p.m.custom.shop_by_interest" || attr == "filter.p.m.custom.shop_by_team"){
      // console.log("attr",attr);
      if(event.target.closest(".custom-filter-ul")){
        // add disabled for prevent fast clicking
        let filterListAll = event.target.closest(".custom-filter-ul").querySelectorAll(".list-menu__item input");
        if(filterListAll.length){
          filterListAll.forEach(input => {
            if(input != event.target) input.setAttribute("disabled","true");
          });
        }
        
        let filterList = event.target.closest(".custom-filter-ul").querySelectorAll(".list-menu__item.active");
        if(filterList.length){
          filterList.forEach(item => {
            // console.log("item",item);
            if(item.querySelector("input")){
              item.querySelector("input").checked = false;
            }
          });
        }
      }
    }
    
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
